export const DEBOUNCE_DELAY = 200;

export const CALENDLY_HREF = "https://calendly.com/d/2ym-7cj-35z/moment-call";
